import { render } from "./UnreviewedClientPosts.vue?vue&type=template&id=5243333b&ts=true"
import script from "./UnreviewedClientPosts.vue?vue&type=script&lang=ts"
export * from "./UnreviewedClientPosts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__